module.exports = __webpack_public_path__ + "img/news-for-you-image.c6cba73a.png";